import React, { useState, useEffect } from "react";
import { useToast, Wrap, WrapItem } from "@chakra-ui/react";
import MontainHead from "../assets/Montain1.png";
import MontainBack from "../assets/Montain2.png";
import NavigationImage from "../assets/SettingLevel.png";
import { Link } from "react-router-dom"; // Asegúrate de importar Link
import Level from "./Level";
import TazaLevel from "../assets/TazaLevel.png";
import LockedLevel from "../assets/LockLevel.png";
import axios from "../lib/axios.js";
import { useSelector } from "react-redux";
import Boy from "../assets/kidsAvatar/Boy.png";
import Girl from "../assets/kidsAvatar/Girl.png";
import { useNavigate } from "react-router-dom";

function DashboardKids() {
  const kid = useSelector((state) => state.kid.selectedKid);
  const [levels, setLevels] = useState([]);
  const [completedLevels, setCompletedLevels] = useState([]);
  const navigate = useNavigate();
  const toast = useToast();
  const handleClick = (nivelId) => {
    console.log(nivelId);
    // Guardar nivelId en localStorage
    localStorage.setItem("nivelId", nivelId);
  };
  if (!kid) {
    navigate("/Login");
  }
  useEffect(() => {
    //GET LEVELS
    axios
      .get(`/Levels`)
      .then((response) => {
        if (response.data.success) {
          toast({
            title: "Welcome",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setLevels(response.data.data);
        } else {
          toast({
            title: "Error loading levels",
            description: response.data.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    //GET MY COMPLETED LEVELS
    axios
      .get(`/Levels/levels-completed/${kid.hijoId}`)
      .then((response) => {
        if (response.data.success) {
          setCompletedLevels(response.data.data);
        } else {
          toast({
            title: "Error loading levels",
            description: response.data.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  useEffect(() => {
    // Selecciona todos los elementos con la clase 'css-h94677'
    const elements = document.getElementsByClassName("css-h94677");

    // Aplica los estilos a todos los elementos encontrados
    for (let element of elements) {
      element.style.margin = "0";
      element.style.padding = "0";
    }

    // Opcional: Limpieza al desmontar el componente
    return () => {
      for (let element of elements) {
        // Restablecer estilos si es necesario
        element.style.margin = ""; // Vuelve al valor por defecto o inicial
        element.style.padding = ""; // Vuelve al valor por defecto o inicial
      }
    };
  }, []);

  return (
    <div
      style={{
        margin: "0",
        padding: "0",
        width: "100vw",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#FFF", // Agregado para visualización, puede removerse si es necesario
      }}
      className="css-h94677"
    >
      <Wrap spacing="30px" justify="center">
        {levels.map((level, index) => {
          const isCompleted = completedLevels.find(
            (x) => x.nivelId === level.nivelId
          );
          const isNextUnlocked = index === completedLevels.length;
          const isClickable = isCompleted || isNextUnlocked;
          const marginStyle =
            index % 2 === 0
              ? {
                  marginTop: "10px",
                  marginBottom: "150px",
                  marginRight: "40px",
                }
              : {
                  marginTop: "150px",
                  marginBottom: "10px",
                  marginRight: "40px",
                };

          return (
            <WrapItem key={index} boxShadow="none" style={marginStyle}>
              {isClickable ? (
                <Link to="/Game">
                  <div onClick={() => handleClick(level.nivelId)}>
                    <Level
                      zIndex={50}
                      backgroundColor={
                        isCompleted
                          ? "#FCEBA2"
                          : isNextUnlocked
                          ? "#F0F0F0"
                          : "#BDBDBD"
                      }
                      borderColor={
                        isCompleted
                          ? "#FCEBA2"
                          : isNextUnlocked
                          ? "#F0F0F0"
                          : "#BDBDBD"
                      }
                      img={
                        isCompleted
                          ? TazaLevel
                          : isNextUnlocked
                          ? TazaLevel
                          : LockedLevel
                      }
                      number={level.nivelId}
                      text={level.nombre}
                    />
                  </div>
                </Link>
              ) : (
                <div onClick={() => handleClick(level.nivelId)}>
                  {" "}
                  {/* Envuelve el Level en un div con onClick */}
                  <Level
                    zIndex={50}
                    backgroundColor={
                      isCompleted
                        ? "#FCEBA2"
                        : isNextUnlocked
                        ? "#F0F0F0"
                        : "#BDBDBD"
                    }
                    borderColor={
                      isCompleted
                        ? "#FCEBA2"
                        : isNextUnlocked
                        ? "#F0F0F0"
                        : "#BDBDBD"
                    }
                    img={
                      isCompleted
                        ? TazaLevel
                        : isNextUnlocked
                        ? TazaLevel
                        : LockedLevel
                    }
                    number={level.nivelId}
                    text={level.nombre}
                  />
                </div>
              )}
            </WrapItem>
          );
        })}
      </Wrap>

      <Link
        to="/Parents"
        style={{
          position: "absolute",
          left: "80px",
          bottom: "40px",
          zIndex: "60",
        }}
      >
        <img
          src={NavigationImage}
          alt="Navegación a Padres"
          style={{
            height: "auto",
            maxWidth: "100%", // Asegura que la imagen sea responsive y no sobrepase el ancho de la pantalla
          }}
        />
      </Link>
      {/* Logo y Nombre de Usuario */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          display: "flex",
          alignItems: "center",
          zIndex: "10", // Asegura que el logo y el nombre de usuario estén sobre las montañas
        }}
      >
        {kid ? (
          <>
            <img
              src={kid.sexoId === 1 ? Boy : Girl}
              alt="Logo"
              style={{
                height: "91px", // Ajusta según sea necesario
              }}
            />
            <span
              style={{
                marginLeft: "10px", // Separación del logo
                color: "#000", // Color de texto
                fontFamily: "Inter", // Tipo de letra
                fontSize: "20px", // Tamaño de letra
                fontStyle: "normal", // Estilo de fuente
                fontWeight: "400", // Grosor de la fuente
                lineHeight: "normal", // Altura de línea
                letterSpacing: "-0.01px", // Espaciado entre letras
              }}
            >
              {`${kid.nombre + " " + kid.apellido}`}
            </span>
          </>
        ) : (
          <div />
        )}
      </div>

      {/* Montaña de atrás */}
      <img
        src={MontainBack}
        alt="Montaña de atrás"
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          padding: "0",
          margin: "0",
          minWidth: "100%",
          height: "auto",
          objectFit: "cover",
          objectPosition: "bottom left",
        }}
      />

      {/* Montaña de enfrente */}
      <img
        src={MontainHead}
        alt="Montaña de enfrente"
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          padding: "0",
          margin: "0",
          minWidth: "100%",
          height: "auto",
          objectFit: "cover",
          objectPosition: "bottom left",
        }}
      />
    </div>
  );
}

export default DashboardKids;
